import type { IVariable } from "@bbj-types/utils";
import { useState } from "react";

export const useVariablesTextField = (onChange: (value: string) => void) => {
  const [cursorPosition, setCursorPosition] = useState<number | undefined>(undefined);

  const handleAddVariableInField = (value: string | undefined, variable: IVariable) => {
    if (!value) {
      onChange(`{{${variable.value}}}`);
    } else {
      const currentCursorPosition = cursorPosition === undefined ? value.length : cursorPosition;
      const tempSubject = value;
      const enhancedSubject = `${tempSubject.slice(0, currentCursorPosition)}{{${variable.value}}}${tempSubject.slice(
        currentCursorPosition
      )}`;
      onChange(enhancedSubject);
    }
  };

  return {
    cursorPosition,
    setCursorPosition,
    handleAddVariableInField,
  };
};
